import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="read-more"
export default class extends Controller {
  static targets = ["text", "button"]
  static values = {
    visibleLines: {
      type: Number,
      default: 5
    },
    moreText: {
      type: String,
      default: "Read more"
    },
    lessText: {
      type: String,
      default: "Read less"
    }
  }

  CLASSES = {
    1: "line-clamp-1",
    2: "line-clamp-2",
    3: "line-clamp-3",
    4: "line-clamp-4",
    5: "line-clamp-5",
    6: "line-clamp-6"
  }

  connect() {
    this.lineClampClass = this.CLASSES[this.visibleLinesValue]

    if (this.visibleLinesValue < 1 || this.visibleLinesValue > 6)
      throw new Error("visibleLinesValue must be between 1 and 6")

    const allLines = this.getAllLines()
    if (allLines <= this.visibleLinesValue) {
      this.buttonTarget.classList.add("hidden")
    } else {
      this.textTarget.classList.add(this.lineClampClass)
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.textTarget.classList.contains(this.lineClampClass)) {
      this.textTarget.classList.remove(this.lineClampClass)
      this.buttonTarget.textContent = this.lessTextValue
    } else {
      this.textTarget.classList.add(this.lineClampClass)
      this.buttonTarget.textContent = this.moreTextValue
    }
  }

  getAllLines() {
    const lineHeight = parseFloat(window.getComputedStyle(this.textTarget).lineHeight)
    const containerHeight = this.textTarget.clientHeight
    return Math.round(containerHeight / lineHeight)
  }
}
